import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpCircle, Link2Off } from "lucide-react";

const when = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "");

/** Linked-site state on Release Control, plus the newer-version notice production sees. */
export function LinkStatus({ data }) {
  const { link } = data;
  if (!link.linked) {
    return (
      <div className="border p-4 mb-6 text-sm flex flex-wrap items-center gap-2" style={{ borderColor: "var(--border-strong)", background: "var(--bg)" }} data-testid="release-link-missing">
        <Link2Off size={14} /> Not linked to the other site, so its switch states are unknown.
        <Link to="/admin/setup#linked-site" className="underline font-semibold" data-testid="release-link-setup-link">Link the sites in Settings</Link>
      </div>
    );
  }
  if (!link.reachable) {
    return (
      <div className="border p-4 mb-6 text-sm" style={{ borderColor: "#842029", background: "#F8D7DA", color: "#842029" }} data-testid="release-link-error">
        {link.error || "The linked site could not be reached."}
      </div>
    );
  }
  return (
    <div className="mb-6 space-y-3">
      <div className="text-xs" style={{ color: "var(--muted)" }} data-testid="release-link-ok">
        Linked with <span className="font-mono">{link.peer_url}</span> ({data.other_environment}) running v{link.peer_version}
      </div>
      {link.newer_on_peer && (
        <div className="border p-5" style={{ borderColor: "var(--ink)", background: "var(--surface)" }} data-testid="release-newer-version">
          <div className="flex items-center gap-2 font-semibold" style={{ color: "var(--ink)" }}>
            <ArrowUpCircle size={16} /> Newer version available on {data.other_environment === "production" ? "production" : "dev-portal"}: v{link.peer_version}
            {link.peer_built_at && <span className="font-normal text-xs" style={{ color: "var(--muted)" }}>(built {when(link.peer_built_at)})</span>}
          </div>
          {Boolean(link.notes_since.length) && (
            <ul className="mt-3 space-y-2 text-sm" data-testid="release-notes-since">
              {link.notes_since.map((n) => (
                <li key={n.version}><span className="font-mono font-bold">v{n.version}</span> — <span className="font-semibold">{n.title}</span>
                  <span className="block whitespace-pre-line" style={{ color: "var(--muted)" }}>{n.notes}</span></li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}
